module.exports = __webpack_public_path__ + "media/images/zoomlogo-90ab12ebc51c2beb33188b6c4547b035.png";